import React, {useMemo} from "react";
import {useSelector} from "react-redux";

import {isEmpty} from "@pg-mono/nodash";
import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {IRPStore} from "../../../../app/rp_reducer";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {findVariableByValue} from "../../../../property/utils/find_variable_by_value";

export const QuartersCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const variables = useSelector((state: IRPStore) => state.variables.data);
    const property = props.item;

    const quarterTypeList = useMemo(() => {
        return property.quarters
            .reduce((acc, quarter) => {
                const foundQuarter = findVariableByValue(variables?.property_quarters, quarter);

                if (foundQuarter) {
                    acc.push(foundQuarter.label.toLowerCase());
                }

                return acc;
            }, [] as string[])
            .join(", ");
    }, [property.quarters, variables]);

    return <>{isEmpty(property.quarters) ? null : quarterTypeList}</>;
};
import React, {useMemo} from "react";
import {useSelector} from "react-redux";

import {isEmpty} from "@pg-mono/nodash";
import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {IRPStore} from "../../../../app/rp_reducer";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {findVariableByValue} from "../../../../property/utils/find_variable_by_value";

export const QuartersCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const variables = useSelector((state: IRPStore) => state.variables.data);
    const property = props.item;

    const quarterTypeList = useMemo(() => {
        return property.quarters
            .reduce((acc, quarter) => {
                const foundQuarter = findVariableByValue(variables?.property_quarters, quarter);

                if (foundQuarter) {
                    acc.push(foundQuarter.label.toLowerCase());
                }

                return acc;
            }, [] as string[])
            .join(", ");
    }, [property.quarters, variables]);

    return <>{isEmpty(property.quarters) ? null : quarterTypeList}</>;
};
